export default "__VITE_ASSET__Cy8bkAAW__"